import { render, staticRenderFns } from "./dms.vue?vue&type=template&id=9beaf964"
import script from "./dms.vue?vue&type=script&lang=js"
export * from "./dms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports